module.exports = __webpack_public_path__ + "static/media/om_beard_scruff_diamond__v_vector.8de95ee2.svg";